import moment from "moment";
import "moment-timezone";

const timeZone = moment.tz.names().map(zone => {
    return {
        text: zone,
        value: zone
    };
});

export default timeZone;